import React from 'react';
import ProjectIntegrationsPage from 'Pages/ProjectIntegrationsPage';

const ProjectIntegrationsContainer = () => {
  return <ProjectIntegrationsPage/>;
};

export default ProjectIntegrationsContainer;
